<template>
  <div>
    <div class="portlet">
      <div class="portlet-head">
          <h3><i class="fas fa-user-tie"></i> Lista klientów</h3>
          <div>
            <b-button variant="outline-primary" @click="showModal(false, 'customer-modal')">
              <i class="fas fa-plus"></i> Dodaj Klienta
            </b-button>
          </div>
      </div>
      <div class="portlet-body">
        <div class="searchpanel">
          <form @submit.prevent="doSearch">
            <div class="searching searchpanel-item">
              <div class="input-group flex-nowrap">
                <div class="searching-wrapper searchpanel-item">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Szukaj"
                    aria-label="Szukaj"
                    v-model="search"
                  />
                  <span class="searching-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <span class="searching-clean" v-show="search" @click="cleanSearch">
                    <i class="fas fa-times"></i>
                  </span>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-sm btn-outline-secondary d-none" type="submit">Szukaj</button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <b-table
          class="table table-list table-mobilepro"
          ref="customers_table"
          :fields="fields"
          :busy.sync="isBusy"
          :items="getCustomers"
          stacked="lg"
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>
          <template v-slot:head(lastchange)="data">{{ data.label}}</template>
          <template v-slot:head(options)="data">{{ data.label}}</template>
          <template v-slot:cell(fullname)="data">{{ data.item.firstname }} {{ data.item.lastname }}</template>
          <template v-slot:cell(company)="data">
            <i>{{ data.item.companyname }}</i>
            <small class="d-block" v-if="data.item.vat_number">NIP: {{ data.item.vat_number }}</small>
          </template>
          <template v-slot:cell(email)="data">
            <span v-if="data.item.email">
              <i class="far fa-envelope mr-2"></i>
              <a :href="'mailto:'+data.item.email">{{data.item.email}}</a>
            </span>
          </template>
          <template v-slot:cell(phone)="data">
            <span v-if="data.item.phone">
              <i class="fas fa-phone-alt mr-2"></i>
              <a :href="'tel:'+data.item.phone">{{ data.item.phone }}</a>
            </span>
          </template>
          <template v-slot:cell(adress)="data">
            {{data.item.address}}
            <br />
            {{data.item.postcode}} {{data.item.city}}
          </template>
          <template v-slot:cell(lastchange)="data">
            <div
              v-if="data.item.updated_at"
            >{{ data.item.updated_at | date }}</div>
            <div v-else>{{ data.item.created_at | date }}</div>
          </template>
          <template v-slot:cell(options)="data">
              <b-dropdown no-caret right variant="light" class="btn-rounded">
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button @click="showModal(data.item.id,'customer-modal')">Edytuj</b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button class="danger" @click="remove(data.item.id)">
                  <i class="fas fa-trash-alt"></i> Usuń
                </b-dropdown-item-button>
              </b-dropdown>
          </template>
        </b-table>
      </div>
    </div>
    <ModalCustomer
      :customer="selected"
      v-on:onClose="this.handleDeselect"
      v-on:onSubmit="this.handleAppendItem"
    />
  </div>
</template>

<script>
import CustomersService from "@/services/customers.service";

/* depedencies components */
import TableSpiner from "../components/TableSpiner";
import ModalCustomer from "../components/ModalCustomer";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "TheClients",
  components: { TableSpiner, ModalCustomer },
  data() {
    return {
      search: "",
      selected: undefined,
      items: null,
      isBusy: false,
      fields: [
        { key: "fullname", label: "Imię i Nazwisko" },
        { key: "company", label: "Firma" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Tel. Kontaktowy" },
        { key: "adress", label: "Adres" },
        { key: "lastchange", label: "Ostatnia zmiana", class: "text-center" },
        // { key: "note", label: "Notatki" },
        { key: "options", label: "Opcje", class: "text-center" }
      ]
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  methods: {
    cleanSearch() {
      this.search = "";
      this.doSearch();
    },
    doSearch() {
      this.items = null;
      this.$refs.customers_table.refresh();
      return false;
    },
    getCustomers() {
      if (this.$_.isNull(this.items) === false) {
        return this.items;
      }
      this.$Progress.start();
      return CustomersService.search(this.search.trim())
        .then(items => {
          this.items = items;
          return this.items;
        })
        .catch(() => {
          return [];
        });
    },
    remove(customer_id) {
      this.$bvModal
        .msgBoxConfirm("Do you really want to delete this customer?", {
          title: "Confirm delete customer",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO"
        })
        .then(result => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          CustomersService.delete(customer_id).then(() => {
            let index = this.$refs.customers_table.localItems.findIndex(
              user => user.id === customer_id
            );
            if (~index) this.$refs.customers_table.localItems.splice(index, 1);
          });
        });
    },
    showModal(customer_id, modalid) {
      if (customer_id) {
        this.selected = this.$_.find(this.items, { id: customer_id });
      }
      this.$nextTick(() => {
        this.$bvModal.show(modalid);
      });
    },
    handleDeselect: function() {
      this.selected = {};
    },
    handleAppendItem: function(newCustomer) {
      this.items.unshift(newCustomer);
      this.$refs.customers_table.localItems.unshift(newCustomer);
    }
  }
};
</script>
